import { db, functions, storage } from '@/firebase'

export default {
  getBackupsArray({ commit }) {
    return db.collection('backups')
      .orderBy('fecha', 'desc')
      .limit(100)
      .get().then((r) => {
        var res = [];
        console.log(r.size);
        if (r.size > 0) {
          res = r.docs.map(f => {
            return {
              ...f.data(),
              id: f.id
            }
          })
        }
        commit('setBackupsArray', res);
      })
  },
  crearBackup({ }, { colecciones }) {
    var bk = functions.httpsCallable('httpBackupCrearBackup');
    return bk(colecciones)
  },
  eliminarBackup({ }, { id }) {
    var bk = functions.httpsCallable('httpBackupEliminar');
    return bk(id)
  },
  restaurarBackup({ }, { id }) {
    var bk = functions.httpsCallable('httpBackupRestaurar');
    return bk(id)
  },
}